<template>
  <div class="switch" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <BaseCheckbox
        :id="id"
        v-model="checked"
        :error="error"
        :options="options"
        :disabled="disabled"
        @input="emitEvent"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseCheckbox from "@/components/Base/Controls/BaseCheckbox";

export default {
  name: "CheckboxControl",
  components: {
    BaseCheckbox
  },
  extends: BaseFormControl,

  props: {
    value: {
      type: [Boolean, String, Array, Object],
      default: false
    },
    options: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      checked: this.value
    };
  },
  computed: {}
};
</script>

<style lang="scss"></style>
